export enum ProductType {
  ApplianceCare = 'AC',
  BoilerCare = 'BC',
  PlumbingAndDrainage = 'PD',
  SmallDomesticApplianceCare = 'RT',
  RepairAndCare = 'RS',
  RepairBoiler = 'RB',
}
